<template>
	<div>
		<div class="content">
			<div class="container help-center">
				<leftAbout></leftAbout>
				<div class="help-main">
					<h2>联系我们</h2>
					<div class="help-cont">
						<p>产品名称：{{contactUs.wxApp}}</p>
						<p>公司名称：{{contactUs.title}}</p>
						<hr>
						<p>客服热线：{{contactUs.mobile}}<br></p>
						<hr>
						<p>
							<br>
							电话：{{contactUs.mobile}}
							<br>
							QQ：{{contactUs.qq}}
						</p>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import leftAbout from '../common/about/index.vue'
	export default{
		name:"Contace",
		data(){
			return{
				contactUs:[]
			}
		},
		created() {
			this.getContactUs()
		},
		components:{
			leftAbout
		},
		methods:{
			getContactUs() {
				let token = localStorage.getItem('token')
				this.$api.connection({
						token: token,
					})
					.then(result => {
						this.contactUs = result.data
					})
			},
		}
	}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/about/contact.vue